import { render, staticRenderFns } from "./roleManageU.vue?vue&type=template&id=41f8860d&scoped=true"
import script from "./roleManageU.vue?vue&type=script&lang=js"
export * from "./roleManageU.vue?vue&type=script&lang=js"
import style0 from "./roleManageU.vue?vue&type=style&index=0&id=41f8860d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f8860d",
  null
  
)

export default component.exports